<template>
  <div>
    <van-notice-bar
      @click="to"
      class="loadApp"
      mode="closeable"
      @close.stop
      :scrollable="false"
      text="下载未来润美客户端APP"
    />
    <iframe
      id="myIframe"
      :src="url"
      frameborder="0"
      style="width: 100%; padding-top: 0.89rem"
      scrolling="no"
    ></iframe>
  </div>
</template>

<script>
import axios from "axios";
import bus from "../../utils/eventBus";
export default {
  data() {
    return {
      url: "",
    };
  },
  created() {
    if (window.location.href.split("?aid=")[1]) {
      localStorage.setItem("otheraid", window.location.href.split("?aid=")[1]);
    }
    // console.log(this.$route.params)
    if (this.$route.params.article) {
      this.url =
        this.commonRealmName +
        "/index.php/main/news_show/id/" +
        this.$route.params.id;
      sessionStorage.setItem("articleId", this.url);
      sessionStorage.setItem(
        "articleInfo",
        JSON.stringify(this.$route.params.article)
      );
      // 分享
      wxint({
        shareTitle: this.$route.params.article.title,
        shareTxt: this.$route.params.article.content,
        shareUrl: this.$route.params.article.share_url,
        imgUrl: this.$route.params.article.pic,
      });
    } else {
      if (sessionStorage.getItem("articleId")) {
        this.url = sessionStorage.getItem("articleId");
        const info = JSON.parse(sessionStorage.getItem("articleInfo"));
        wxint({
          shareTitle: info.title,
          shareTxt: info.content,
          shareUrl: info.share_url,
          imgUrl: info.pic,
        });
      } else {
        this.url =
          this.commonRealmName +
          "/index.php/main/news_show/id/" +
          this.$route.params.id;
        sessionStorage.setItem("articleId", this.url);
        wxint({
          shareTitle: "文章详情",
          shareTxt: "",
          shareUrl: this.commonRealmName + "/h5/?#" + this.$route.path,
          imgUrl: "",
        });
      }
    }
  },
  mounted() {
    const iframe = document.getElementById("myIframe");
    iframe.onload = () => {
      this.reinitIframe();
    };
  },
  methods: {
    // iframe适配
    reinitIframe() {
      const iframe = document.getElementById("myIframe");
      try {
        const bHeight = iframe.contentWindow.document.body.scrollHeight;
        const dHeight =
          iframe.contentWindow.document.documentElement.scrollHeight;
        const height = Math.max(bHeight, dHeight);
        iframe.height = height + 50;
      } catch (ex) {}
    },
    to() {
      const otheraid = localStorage.getItem("otheraid");
      if (otheraid) {
        window.location.href = this.commonRealmName + "/?aid=" + otheraid;
      } else {
        window.location.href = this.commonRealmName;
      }
    },
  },
  beforeCreate() {
    document.querySelector("body").setAttribute("style", "background:#ffffff");
  },
  beforeDestroy() {
    document.querySelector("body").setAttribute("style", "background:#f3f1f4");
    sessionStorage.removeItem("articleId");
    sessionStorage.removeItem("articleInfo");
  },
};
</script>

<style lang='scss'>
body {
  overflow-x: hidden;
  overflow-y: auto;
  background-color: #ffffff;
}
// 在App中打开
.loadApp {
  position: fixed;
  top: 0.49rem;
  width: 100%;
  z-index: 999;
  height: 0.4rem;
  padding: 0 0.16rem;

  .van-notice-bar__content {
    height: 0.38rem;
    line-height: 0.38rem;
    background-color: rgb(255, 255, 255, 0.5);
    color: #000000;
    font-size: 0.14rem;
  }
  .van-notice-bar__right-icon {
    font-size: 0.16rem;
  }
  .van-notice-bar__content {
    text-indent: 0.35rem;
    background: url("../../assets/img/nav_icon_logo@2x.png") no-repeat center
      left;
    background-size: 0.23rem;
  }
}
.aui-content {
  height: 100%;
}
</style>
